module.exports = __webpack_public_path__ + "img/大哭.59312494.png";